// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"674":"6d35f6f3a644e152ccce","725":"b37bed5945292b9ca907","803":"c0bfa036b5506d176488","859":"92d9bf413474dee0646b","952":"42d3776ac82fad689cf1","971":"d925120bfbd2a4af659b"}[chunkId] + ".chunk.js";
};